import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            authUrl: null,
            clientId: null, 
            companyId: null, 
            redirectUrl: null, 
            connectedLinkedInAccounts: [],
            authBaseUrl: "https://www.linkedin.com/oauth/v2/authorization?client_id="
        }
    },
    getters,
    actions,
    mutations
}